module.exports = __webpack_public_path__ + "static/img/Charlie_Curnow_desktop.a2a8609.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Charlie_Curnow_desktop.jpg
// module id = fg8k
// module chunks = 0